import { Classes, Dialog, Divider, Icon, InputGroup } from "@blueprintjs/core"
import { PlanrPopover } from "modules/common/components/planr/popover/Popover"
import { Buttons } from "modules/common/components/form"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import React, { FC, useState } from "react"

import styles from "./Profile.module.scss"
import { Field, FieldProps, Form, Formik } from "formik"
import { StandardFormInput } from "modules/common/components/form/StandardFormInput"
import { EmployerType, fields } from "modules/spending/employee/models/employer"
import ProfileSchema from "./validation"
import { getSnapshot } from "mobx-state-tree"
import { PlanRDndUploader } from "modules/common/components/planr/dndUploader/FileDndUploader"
import { MimeTypes } from "modules/common/services/files"
import { DatePicker } from "modules/common/components/form/DatePicker"
import { buildPatchEmployer } from "modules/common/services/form/values"
interface ProfileProps {
  show: boolean
  onClose: () => void
  onSave: () => void
  employer: EmployerType
}
export const ACCEPT = [MimeTypes.jpeg, MimeTypes.png].join(",")
const old = new Date(1920, 1, 1)

const schema = ProfileSchema()

const Profile: FC<ProfileProps> = ({ show, onSave, onClose, employer }) => {
  const [showAvatarLoad, setShowAvatarLoad] = useState(false)
  //// const [showChildrenDialog, setShowChildrenDialog] = useState(false);
  // const [childId, setChildId] = useState("");
  // const [showChild, setShowChild] = useState(false);

  // const toggleChildrenDialog = () => {
  //   setShowChildrenDialog(!showChildrenDialog);
  // };

  // const toggleChild = () => {
  //   setShowChild(!showChild);
  // };

  const toggleAvatarLoad = () => {
    setShowAvatarLoad(!showAvatarLoad)
  }

  const initial = getFormValues(employer)
  return (
    <div>
      <Formik
        initialValues={initial}
        enableReinitialize={true}
        validationSchema={schema}
        onSubmit={async (values, { setSubmitting, resetForm }) => {
          const succsessfull = await employer.saveProfile(buildPatchEmployer(initial, values))
          setSubmitting(false)
          if (succsessfull) {
            resetForm()
            onSave() // employer.id
          }
        }}
      >
        {(formProps) => {
          return (
            <Form autoComplete="off">
              <Dialog
                title={`Редактирования профиля`}
                isOpen={show}
                onClose={onClose}
                backdropClassName="standard"
                className={` figma-dialog`}
              >
                <div className={`${Classes.DIALOG_BODY} `}>
                  <div>
                    <Field name={fields.avatar}>
                      {({ form, field }: FieldProps) => {
                        const onFileSelected = async (file: File) => {
                          var reader = new FileReader()
                          // const updateAvatar = (str: any) => {
                          //     this.setState({ avatar: str });
                          // };
                          reader.readAsDataURL(file)
                          reader.onload = () => {
                            form.setFieldValue(field.name, reader.result)
                            form.setFieldTouched(field.name, true)
                            toggleAvatarLoad()
                          }
                          reader.onerror = function (error) { }
                        }

                        const onRemove = () => {
                          form.setFieldValue(field.name, "")
                          form.setFieldTouched(field.name, true)
                        }

                        return (
                          <div className={styles.avatar}>
                            <Dialog
                              icon="info-sign"
                              title="Загрузка фото сотрудника"
                              canEscapeKeyClose={true}
                              canOutsideClickClose={true}
                              isOpen={showAvatarLoad}
                              onClose={toggleAvatarLoad}
                              style={{ width: `500px` }}
                              backdropClassName="standard"
                            >
                              <div className={Classes.DIALOG_BODY}>
                                <div className={styles.avatarLoad}>
                                  <div>Примечания: </div>

                                  <ul>
                                    <li>Цветная фотография (ТОЛЬКО ЛИЦО);</li>
                                    <li>
                                      Ваше лицо не должно быть скрыто очками, шляпой или иными предметами, должно быть
                                      этичным;
                                    </li>
                                    <li>Размер изображения не более 5 мб;</li>
                                    <li>Формат – JPEG, PNG;</li>
                                    <li>Разрешение: 120х120px.</li>
                                  </ul>
                                  <div>
                                    <PlanRDndUploader accept={ACCEPT} onFileSelected={onFileSelected} />
                                  </div>
                                </div>
                              </div>
                            </Dialog>
                            <span className={styles.avatarText}>Фото</span>

                            <div style={{ marginRight: "18px" }}>
                              {field.value ? (
                                <PlanrPopover
                                  interactionKind="hover"
                                  className="planr-column-selector"
                                  content={
                                    <div className={styles.bigAvatarContainer}>
                                      {field.value ? (
                                        <img src={field.value} alt={"avatar"} className={styles.bigAvatar} />
                                      ) : (
                                        <Icon icon="user" size={120} />
                                      )}
                                    </div>
                                  }
                                >
                                  <img src={field.value} alt={"avatar"} className={styles.avatarImage} />
                                </PlanrPopover>
                              ) : (
                                <Icon icon="user" size={55} />
                              )}
                            </div>
                            <PlanrButton
                              type="lightgreenish"
                              size="small"
                              icon="general-plus-big"
                              onClick={toggleAvatarLoad}
                            />
                            <PlanrButton type="secondary" size="small" icon="general-trash" onClick={onRemove} />
                          </div>
                        )
                      }}
                    </Field>
                  </div>
                  <StandardFormInput name={fields.email} schema={schema} small={true} className="planr-form-input">
                    {({ field }) => (
                      <InputGroup id={field.name} {...field} className="planr-default-input" autoComplete="off" small />
                    )}
                  </StandardFormInput>
                  <StandardFormInput name={fields.phone} schema={schema} small={true} className="planr-form-input">
                    {({ field }) => (
                      <InputGroup id={field.name} {...field} className="planr-default-input" autoComplete="off" small />
                    )}
                  </StandardFormInput>
                  <StandardFormInput name={fields.birthday} schema={schema} small={true} className="planr-form-input">
                    {({ field, form }) => {
                      return (
                        <div className={`${Classes.INPUT_GROUP} `}>
                          <DatePicker
                            clasName="planr-default-input"
                            value={field.value}
                            onChange={(date) => {
                              form.setFieldValue(field.name, date)
                              form.setFieldTouched(field.name, true)
                            }}
                            small
                            minDate={old}
                          />
                        </div>
                      )
                    }}
                  </StandardFormInput>
                  <StandardFormInput name={fields.address} schema={schema} small={true} className="planr-form-input">
                    {({ field }) => (
                      <InputGroup id={field.name} {...field} className="planr-default-input" small autoComplete="off" />
                    )}
                  </StandardFormInput>

                  <StandardFormInput name={fields.hobby} schema={schema} small={true} className="planr-form-input">
                    {({ field }) => (
                      <InputGroup id={field.name} {...field} small className="planr-default-input" autoComplete="off" />
                    )}
                  </StandardFormInput>
                  <StandardFormInput name={fields.signDateTo} schema={schema} small={true} className="planr-form-input">
                    {({ field, form }) => {
                      return (
                        <div className={`${Classes.INPUT_GROUP} `}>
                          <DatePicker
                            clasName="planr-default-input"
                            value={field.value}
                            onChange={(date) => {
                              form.setFieldValue(field.name, date)
                              form.setFieldTouched(field.name, true)
                            }}
                            small
                            minDate={old}
                          />
                        </div>
                      )
                    }}
                  </StandardFormInput>
                  {/* <StandardFormInput
                    name={fields.birthday}
                    schema={schema}
                    small={true}
                    className="planr-form-input"
                    label="Дети"
                  >
                    {() => (
                      <div style={{ display: "flex" }}>
                        <InputGroup
                          value={employer.childCount}
                          small
                          className="planr-default-input"
                          autoComplete="off"
                          readOnly={true}
                        />
                        <PlanrButton
                          size="small"
                          type="secondary"
                          onClick={toggleChildrenDialog}
                          style={{ marginLeft: "10px" }}
                        >
                          Список
                        </PlanrButton>
                      </div>
                    )}
                  </StandardFormInput> */}
                  {/* <Dialog
                    icon="info-sign"
                    title="Дети"
                    canEscapeKeyClose={true}
                    canOutsideClickClose={false}
                    isOpen={showChildrenDialog}
                    onClose={toggleChildrenDialog}
                    style={{ width: `620px` }}
                    backdropClassName="standard"
                  >
                    <div className={Classes.DIALOG_BODY}>
                      <div>
                        {employer.children && employer.children.length > 0 && (
                          <div className={styles.childrenRow} style={{ fontWeight: "bold" }}>
                            <div className={styles.childrenRowName}>Имя</div>
                            <div className={styles.childrenRowBDay}>Дата рождения</div>
                            <div className={styles.childrenRowDel}></div>
                          </div>
                        )}

                        {employer.children &&
                          employer.children.map((child) => (
                            <div
                              key={child.guid}
                              className={styles.childrenRow}
                              onDoubleClick={() => {
                                setChildId(child.guid);
                                toggleChild();
                              }}
                            >
                              <div className={styles.childrenRowName}>{child.name}</div>
                              <div className={styles.childrenRowBDay}>{child.birthday}</div>
                              <div className={styles.childrenRowDel}>
                                <GeneralIcon
                                  type="general-trash"
                                  style={{ color: "red", cursor: "pointer" }}
                                  onClick={() => employer.removeChild(child.guid)}
                                />
                              </div>
                            </div>
                          ))}
                        <div className={styles.checkers} style={{ marginTop: "20px" }}>
                          <PlanrButton type="secondary" onClick={toggleChild}>
                            Добавить
                          </PlanrButton>
                          <PlanrButton style={{ marginLeft: "10px" }} type="graybtn" onClick={toggleChildrenDialog}>
                            Закрыть
                          </PlanrButton>
                        </div>
                      </div>
                    </div>
                  </Dialog>
                  <Dialog
                    icon="info-sign"
                    title=""
                    canEscapeKeyClose={true}
                    canOutsideClickClose={false}
                    isOpen={showChild}
                    onClose={toggleChild}
                    style={{ width: `600px` }}
                    backdropClassName="standard"
                  >
                    {<ChildDetails childId={childId} employer={employer} hideDialog={toggleChild} canChange={true} />}
                  </Dialog> */}
                  <Divider style={{ marginTop: "15px" }} />
                  <br />
                  <div className={styles.credentials}>
                    <div>
                      <StandardFormInput name={fields.login} schema={schema} small={true} className="planr-form-input">
                        {({ field }) => (
                          <InputGroup
                            id={field.name}
                            {...field}
                            className="planr-default-input"
                            autoComplete="off"
                            small
                          />
                        )}
                      </StandardFormInput>

                      <StandardFormInput
                        name={fields.newPassword}
                        schema={schema}
                        small={true}
                        label={"Новый пароль"}
                        className="planr-form-input"
                      >
                        {({ field }) => (
                          <InputGroup
                            id={field.name}
                            {...field}
                            className="planr-default-input"
                            autoComplete="off"
                            small
                          />
                        )}
                      </StandardFormInput>

                      {/* смена пароля - только с текущим паролем: сервер без него пароль не меняет */}
                      {!!(formProps.values as any)[fields.newPassword] && (
                        <Field name="currentPassword">
                          {({ field }: FieldProps) => (
                            <div className="planr-form-input">
                              <label className={Classes.LABEL} htmlFor="currentPassword">
                                Текущий пароль
                              </label>
                              <InputGroup
                                id="currentPassword"
                                {...field}
                                value={field.value ?? ""}
                                type="password"
                                className="planr-default-input"
                                autoComplete="current-password"
                                small
                              />
                            </div>
                          )}
                        </Field>
                      )}
                    </div>
                  </div>
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                  <Buttons
                    left={
                      <div style={{ display: "flex" }}>
                        <PlanrButton
                          size="small"
                          type="greenish"
                          onClick={() => {
                            formProps.handleSubmit()
                          }}
                        >
                          Сохранить
                        </PlanrButton>
                        <PlanrButton size="small" type="graybtn" onClick={onClose}>
                          Отмена
                        </PlanrButton>
                      </div>
                    }
                  />
                </div>
              </Dialog>
            </Form>
          )
        }}
      </Formik>
    </div>
  )

  function getFormValues(employer: EmployerType) {
    return {
      ...getSnapshot(employer),
      [fields.phone]: employer.formattedPhone,
      [fields.birthday]: employer.birthdayAsDate,
      [fields.signDateTo]: employer.signToAsDate,
      [fields.positionId]: employer.employePositionId,
      [fields.children]: employer.children,
    }
  }
}

export default Profile
